var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{attrs:{"readonly":_vm.readonly,"rows":_vm.rows},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }